import { instance, GETREQUESTOPTIONS } from '../apiService';

const getAccessLimitOverview = async (days = 14) => {
    const response = await instance.get(
        `/api/access-limits/overview?days=${days}`,
        GETREQUESTOPTIONS()
    );
    return response.data;
};

const getAccessLimitUsers = async (dayUtc?: string, limit = 200) => {
    const dayPart = dayUtc ? `dayUtc=${encodeURIComponent(dayUtc)}&` : '';
    const response = await instance.get(
        `/api/access-limits/users?${dayPart}limit=${limit}`,
        GETREQUESTOPTIONS()
    );
    return response.data;
};

const enqueueAccessLimitAggregation = async (
    dayUtc: string,
    feature?: 'implant_load' | 'file_download'
) => {
    const response = await instance.post(
        '/api/access-limits/aggregate',
        { dayUtc, feature: feature || undefined },
        GETREQUESTOPTIONS()
    );
    return response.data;
};

const getAccessLimitAggregationJob = async (jobId: string) => {
    const response = await instance.get(
        `/api/access-limits/aggregate/jobs/${encodeURIComponent(jobId)}`,
        GETREQUESTOPTIONS()
    );
    return response.data;
};

const preflightImplantLoad = async (id: string) => {
    return instance.get(
        `/api/access-limits/preflight/implant/${encodeURIComponent(id)}`,
        GETREQUESTOPTIONS()
    );
};

const accessLimitService = {
    getAccessLimitOverview,
    getAccessLimitUsers,
    enqueueAccessLimitAggregation,
    getAccessLimitAggregationJob,
    preflightImplantLoad,
};

export default accessLimitService;
